import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import hexToRgba from 'hex-rgba';
import rgbaToHex from 'rgb2hex';
import Color from 'color';
import {
  allowMultiSelectAssetModal,
  disallowMultiSelectAssetModal,
  setAssetModalMimeTypes,
  toggleAssetModal,
} from 'Actions/UIActions';
import { selectAsset } from 'Actions/folderAssetActions';

import WveInputText from 'SharedComponents/WveInputs/WveInputText/WveInputText';
import WveInputAsset from 'SharedComponents/WveInputs/WveInputAsset/WveInputAsset';
import WveInputSelect from 'SharedComponents/WveInputs/WveInputSelect/WveInputSelect';
import WveInputTags from 'SharedComponents/WveInputs/WveInputTags/WveInputTags';
import WveInputIntegerPair from 'SharedComponents/WveInputs/WveInputIntegerPair/WveInputIntegerPair';
import WveInputNumber from 'SharedComponents/WveInputs/WveInputNumber/WveInputNumber';
import WveInputCheckbox from 'SharedComponents/WveInputs/WveInputCheckbox/WveInputCheckbox';
import WveInputColor from 'SharedComponents/WveInputs/WveInputColor/WveInputColor';
import WveInputButton from 'SharedComponents/WveInputs/WveInputButton/WveInputButton';
import WveInputEditButton from 'SharedComponents/WveInputs/WveInputEditButton/WveInputEditButton';
import WveInputFont from 'SharedComponents/WveInputs/WveInputFont/WveInputFont';
import WveInputFontWeight from 'SharedComponents/WveInputs/WveInputFontWeight/WveInputFontWeight';
import WveInputEase from 'SharedComponents/WveInputs/WveInputEase/WveInputEase';
import WveInputViewport from 'SharedComponents/WveInputs/WveInputViewport/WveInputViewport';
import WveInputOffsetHeight from 'SharedComponents/WveInputs/WveInputOffsetHeight/WveInputOffsetHeight';
import WveInputAlignment from 'SharedComponents/WveInputs/WveInputAlignment/WveInputAlignment';

class WveStyleElementControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shiftDown: false,
    };
    this.step = this.props.inputType === 'float' ? 0.1 : 1;
    this.foundAsset = null;
  }
  shouldComponentUpdate(nextProps, nextState) {
    // the use of this is discouraged, but we'll keep for now
    const valueChanged = nextProps.value !== this.props.value;
    const optionsChanged = nextProps.options !== this.props.options;
    const stepChanged = nextState.shiftDown !== this.state.shiftDown;
    const disabledChanged = nextProps.disabled !== this.props.disabled;
    return valueChanged || optionsChanged || stepChanged || disabledChanged;
  }
  didShiftkeyDown = (event) => {
    // shift was up now its down
    if (!this.state.shiftDown && !event.shiftKey) return;
    this.step = this.props.inputType === 'float' ? 0.2 : 10;
    this.setState({ shiftDown: true });
  }
  didShiftkeyUp = (event) => {
    // shift was down now its up
    if (this.state.shiftDown && event.shiftKey) return;
    this.step = this.props.inputType === 'float' ? 0.1 : 1;
    this.setState({ shiftDown: false });
  }
  shouldUpdateValue = (event) => {
    return event.key === 'Enter'
        || event.key === 'ArrowUp'
        || event.key === 'ArrowDown'
        || event.type === 'blur'
        // or event from colour picker
        || event.hex;
  }
  prepareNewValue = (event, eventType, id, oldValue) => {
    let value = event.target.value;
    switch (eventType) {
      case 'blur':
        // revert value if empty
        if(value.toString().trim() === ""){
          value = id
            ? this.props.value[id]
            : this.props.value;
        }
        break;
      case 'keydown':
        // maunally stepup/stepdown value
        value = event.key === 'ArrowUp'
          ? (parseFloat(value) || 0) + this.step
          : (parseFloat(value) || 0) - this.step;
        break;
      case 'hex':
        // revert value if hex is < 6 chars
        value = value.length < 6 ? oldValue : `#${value}`;
        break;
      case 'alpha':
        // revert value if empty
        if(value.toString().trim() === "") value = oldValue;
        // maunally stepup/stepdown value
        if(event.type === 'keydown'){
          value = event.key === 'ArrowUp'
            ? parseFloat(value) + this.step
            : parseFloat(value) - this.step;
          // revert if needed
          if(value < 0) value = 0;
          if(value > 100) value = 100;
        }
        break;
    }
    if (eventType !== 'hex') value = parseFloat(value);
    return value;
  }
  updateCompositeValue = (event) => {
    const { mapping } = this.props;
    this.didShiftkeyDown(event);
    const id = parseInt(event.target.dataset.id, 10);
    const value = this.prepareNewValue(event, event.type, id);
    let style = {};

    if (mapping.includes('left')) {
      if (id === 0) style.left = parseInt(value, 10);
      if (id === 1) style.top = parseInt(value, 10);
    } else if (mapping[0].includes('.left')) {
      style.key = mapping[0].split('.')[0];
      if (id === 0) style.left = parseInt(value, 10);
      if (id === 1) style.top = parseInt(value, 10);
    } else if (mapping.includes('width')) {
      if (id === 0) style.width = Math.max(1, parseInt(value, 10));
      if (id === 1) style.height = Math.max(1, parseInt(value, 10));
    } else if (mapping[0].includes('.width')) {
      style.key = mapping[0].split('.')[0];
      if (id === 0) style.width = Math.max(1, parseInt(value, 10));
      if (id === 1) style.height = Math.max(1, parseInt(value, 10));
    } else if (mapping.includes('transformOrigin')) {
      const valueOne = id === 0 ? value : this.props.value[0];
      const valueTwo = id === 1 ? value : this.props.value[1];
      style = { transformOrigin: `${parseInt(valueOne, 10)}% ${parseInt(valueTwo, 10)}%` };
    }
    this.props.updateFunction(style);
  }
  handlePercentageUpdate = (event) => {
    this.didShiftkeyDown(event);
    let value = this.prepareNewValue(event, event.type) / 100;

    if (typeof this.props.max !== 'undefined' && value > this.props.max) {
      value = this.props.max;
    }

    if (typeof this.props.min !== 'undefined' && value < this.props.min) {
      value = this.props.min;
    }

    if ((typeof this.props.units === 'undefined') || this.props.discardUnits) {
      this.updateValue(value);
    } else {
      this.updateValue(value + this.props.units);
    }
    return value * 100;
  }
  handleNumberUpdate = (event) => {
    this.didShiftkeyDown(event);
    let value = this.prepareNewValue(event, event.type);
    if (isNaN(value)) return;

    if (typeof this.props.max !== 'undefined' && value > this.props.max) {
      value = this.props.max;
    }

    if (typeof this.props.min !== 'undefined' && value < this.props.min) {
      value = this.props.min;
    }

    if ((typeof this.props.units === 'undefined') || this.props.discardUnits) {
      this.updateValue(value);
    } else {
      this.updateValue(value + this.props.units);
    }
    return value;
  }
  handleBoolUpdate = (event) => {
    const value = event.target.checked;
    this.updateValue(value);
  }
  handleColourUpdate = (event) => {
    this.didShiftkeyDown(event);
    let value, newHex, newAlpha;

    if (event.rgb) {
      // event came from colour picker
      const { r, g, b, a } = event.rgb;
      value = `rgba(${r}, ${g}, ${b}, ${a})`;
    } else {
      // event came from hex or alpha inputs:
      // get the current rgba value
      value = this.props.value;
      if (value.includes('#')) value = hexToRgba(value);
      // separate hex and alpha from rgba
      const { hex, alpha } = rgbaToHex(value);
      newHex = hex;
      newAlpha = alpha * 100;
      // update the new part
      if (event.target.name === 'hex') newHex = this.prepareNewValue(event, 'hex', null, hex);
      if (event.target.name === 'alpha') newAlpha = this.prepareNewValue(event, 'alpha', null, newAlpha);
      // merge back together
      const rgb = Color(newHex).rgb().array();
      value = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${newAlpha / 100})`;
    }
    this.updateValue(value);
    return { newHex, newAlpha };
  }

  handleUpdate = (value) => {
    if (value === null) return this.updateValue(null);
    const updatedValue = Array.isArray(value) ? value.map(v => v.key) : value.key;
    this.updateValue(updatedValue);
  }

  updateValue = (value, skipHistory = false) => {
    const { mapping } = this.props;

    if (mapping === 'trigger' && value === 'none') this.props.updateFunction({ event: 'none' });

    this.props.updateFunction({ [mapping]: value }, skipHistory);
  }
  handleClick() {
    window[this.props.value]();
  }
  handleAssetClick = () => {
    const { mimeTypes, multipleSelect } = this.props;
    if (multipleSelect){
      this.props.allowMultiSelectAssetModal();
    } else {
      this.props.disallowMultiSelectAssetModal();
    }
    this.props.selectAsset(this.foundAsset);
    this.props.setAssetModalMimeTypes(mimeTypes);
    this.props.toggleAssetModal()
  }
  handleBlur = (event) => {
    let value = event.target.value;
    const failedPatternCheck = this.props.pattern !== '' && !event.target.checkValidity();
    if (failedPatternCheck && this.props.mapping === 'clickthroughUrl') value = `http://${event.target.value}`;
    this.updateValue(value);
  }
  handleTags = (tags) => {
    this.updateValue(tags, true);
  }
  handleTextInput = (e) => {
    this.updateValue(e.target.value, true);
  }
  render() {
    let value = this.props.value;
    const { didShiftkeyUp: handleKeyUp, step } = this;
    const { title, units, placeholder, min, max, inputType, disabled } = this.props;
    const inputProps = { value, title, units, handleKeyUp, min, max, step, placeholder, disabled };
    let inputControl = null;

    switch (inputType) {
      case 'text':
        inputControl = (<WveInputText
          value={value}
          onChange={this.handleTextInput}
          placeholder={this.props.placeholder}
          pattern={this.props.pattern}
          onBlur={this.handleBlur}
          disabled={this.props.disabled}
        />);
        break;
      case 'asset':
        const assetIds = value || [];
        let assetIdsArray = [];
        let i = 0;
        while(assetIds[i] !== undefined){
          assetIdsArray.push(assetIds[i]);
          i++;
        }
        const assets = this.props.assets.filter(a => assetIdsArray.indexOf(a.id) > -1);
        const { mimeTypes } = this.props;
        const mimeTypesForSelection = mimeTypes.includes('text/plain') ? ['video/mp4', 'video/webm', 'video/ogg', 'video/x-theora+ogg', 'video/3gpp', 'video/x-flv','application/vnd.apple.mpegurl'] : mimeTypes;
        const foundAsset = assets.find(asset => mimeTypesForSelection.includes(asset.mime_type));
        const { name: fileName } = foundAsset || {name: ''};
        this.foundAsset = foundAsset;

        inputControl = (<WveInputAsset
          title={fileName}
          value={fileName}
          onClick={this.handleAssetClick}
          disabled={this.props.disabled}
        />);
        break;
      case 'select':
        inputControl = (<WveInputSelect
          value={value}
          onChange={this.handleUpdate}
          options={this.props.options}
          multi={this.props.multipleSelect}
          searchable={this.props.searchable}
          clearable={this.props.clearable}
          disabled={this.props.disabled}
          classes={'wve-form-item-long'}
        />);
        break;
      case 'tags':
        inputControl = (<WveInputTags
          value={value}
          placeholder={this.props.placeholder}
          onChange={this.handleTags}
          disabled={this.props.disabled}
          classes={'wve-form-item-long'}
        />);
        break;
      case 'ease':
        inputControl = (<WveInputEase
          value={value}
          onChange={this.updateValue}
          options={this.props.options}
          disabled={this.props.disabled}
        />);
        break;
      case 'percentage':
        inputProps.value *= 100;
        inputControl = (<WveInputNumber
          handleUpdate={this.handlePercentageUpdate}
          {...inputProps}
        />);
        break;
      case 'integer':
      case 'float':
        inputControl = <WveInputNumber {...inputProps} handleUpdate={this.handleNumberUpdate} />;
        break;
      case 'integerPair': {
        inputControl = (<WveInputIntegerPair
          handleUpdate={this.updateCompositeValue}
          {...inputProps}
        />);
        break;
      }
      case 'bool':
        inputControl = (<WveInputCheckbox
          label={this.props.label}
          value={value}
          onChange={this.handleBoolUpdate}
        />);
        break;
      case 'color':
        let rgba;
        let hex;
        let alphaPercentage;
        let alpha;
        if (value === 'multiple') {
          rgba = 'multiple';
          hex = 'multiple';
          alphaPercentage = 'multiple';
        } else {
          rgba = String(value);
          if (rgba.includes('#')) rgba = hexToRgba(rgba);
          if (!rgba.includes('rgba')) rgba = 'rgba(0,0,0,1)';
          const rgbaAndHex = rgbaToHex(rgba);
          hex = rgbaAndHex.hex;
          alpha = rgbaAndHex.alpha;

          alphaPercentage = alpha * 100;
        }

        const {
          props: { title, placeholder, disabled },
          didShiftkeyUp: handleKeyUp,
          step,
          handleColourUpdate,
        } = this;
        const inputPropsColor = {
          rgba,
          hex,
          alphaPercentage,
          handleKeyUp,
          title,
          placeholder,
          step,
          disabled,
        };
        inputControl = (<WveInputColor {...inputPropsColor} handleUpdate={handleColourUpdate} />);
        break;
      case 'button':
        inputControl = (<WveInputButton
          onClick={this.handleClick}
          classes={'wve-input-long form-control'}
        >{this.props.label}
        </WveInputButton>);
        break;
      case 'constraints':
        inputControl = (<input />);
        break;
      case 'font':
        inputControl = (<WveInputFont />);
        break;
      case 'fontWeight':
        inputControl = (<WveInputFontWeight />);
        break;
      case 'editButton':
        inputControl = (<WveInputEditButton />);
        break;
      case 'viewport':
        inputControl = (
          <WveInputViewport
            inputProps={inputProps}
            handleNumberUpdate={this.handleNumberUpdate}
          />
        );
        break;
      case 'offsetHeight':
        inputControl = (
          <WveInputOffsetHeight
            inputProps={inputProps}
            handleNumberUpdate={this.handleNumberUpdate}
          />
        );
        break;
      case 'alignment':
        inputControl = <WveInputAlignment />;
        break;
    }

    return inputControl;
  }
}

WveStyleElementControl.propTypes = {
  discardUnits: PropTypes.bool,
  label: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  mapping: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  inputType: PropTypes.string,
  addFunction: PropTypes.func,
  updateFunction: PropTypes.func,
  options: PropTypes.array,
  defaults: PropTypes.array,
  placeholder: PropTypes.string,
  units: PropTypes.string,
  min: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.array,
  ]),
  max: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.array,
  ]),
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool,
    PropTypes.string,
    PropTypes.array,
  ]),
  handleAssetInputClick: PropTypes.func,
  mimeTypes: PropTypes.array,
  multipleSelect: PropTypes.bool,
  searchable: PropTypes.bool,
  clearable: PropTypes.bool,
  pattern: PropTypes.string,
  disabled: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
  return {
    assets: state.get('assets'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    allowMultiSelectAssetModal: () => {
      dispatch(allowMultiSelectAssetModal());
    },
    disallowMultiSelectAssetModal: () => {
      dispatch(disallowMultiSelectAssetModal());
    },
    setAssetModalMimeTypes: (assetModalMimeTypes) => {
      dispatch(setAssetModalMimeTypes(assetModalMimeTypes));
    },
    selectAsset: (asset, append) => {
      dispatch(selectAsset(asset, append));
    },
    toggleAssetModal: (asset, append) => {
      dispatch(toggleAssetModal());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WveStyleElementControl);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/components/WveSettingsPanel/WveStyleElement/WveStyleElementControl/WveStyleElementControl.jsx